// extracted by mini-css-extract-plugin
module.exports = {"nounButton":"NounInfoRowButton_nounButton__3kRR_","nounButtonContents":"NounInfoRowButton_nounButtonContents__33b3h","buttonIcon":"NounInfoRowButton_buttonIcon__RtQbH"};